import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import Loader from "../../containers/Loader/Loader";

axios.defaults.withCredentials = true;

const AlumniProtectedRoutes = ({ children, role = "alumni", mode = "auth" }) => {
  const [status, setStatus] = useState("checking");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let mounted = true;

    setStatus("checking");

    const verify = async () => {
      try {
        if (mode === "guest") {
          const [alumniRes, adminRes] = await Promise.allSettled([
            axios.get("/backend/alumni/login_verification"),
            axios.get("/backend/admin/login_verification"),
          ]);

          if (!mounted) return;

          let authorizedAs = null;

          if (
            adminRes.status === "fulfilled" &&
            adminRes.value.data?.token_status === "okay"
          ) {
            authorizedAs = "admin";
          } else if (
            alumniRes.status === "fulfilled" &&
            alumniRes.value.data?.token_status === "okay"
          ) {
            authorizedAs = "alumni";
          }

          if (authorizedAs) {
            setIsAuthorized(true);
            setStatus(authorizedAs);
          } else {
            setIsAuthorized(false);
            setStatus("unauthorized");
          }
        } else {
          const endpoint = role === "admin"
            ? "/backend/admin/login_verification"
            : "/backend/alumni/login_verification";

          const response = await axios.get(endpoint, {
            withCredentials: true,
          });

          if (!mounted) return;

          if (
            response.data.token_status === "okay" &&
            response.data.access === role
          ) {
            setIsAuthorized(true);
            setStatus("authorized");
          } else {
            setIsAuthorized(false);
            setStatus("unauthorized");
          }
        }
      } catch (error) {
        if (mounted) {
          setIsAuthorized(false);
          setStatus("unauthorized");
        }
      }
    };

    verify();

    return () => {
      mounted = false;
    };
  }, [role, mode, location.pathname]);

  if (status === "checking") {
    return <Loader />;
  }

  if (mode === "guest") {
    if (isAuthorized && !location.state?.loggedOut) {
      return (
        <Navigate
          to={status === "admin" ? "/admin-dashboard" : "/pjc-dashboard"}
          replace
        />
      );
    }
    return children;
  }

  if (!isAuthorized) {
    return <Navigate to="/alumni-login" replace />;
  }

  return children;
};

export default AlumniProtectedRoutes;